<template>
  <el-container class="app-shell">
    <el-aside width="220px">
      <AppSidebar />
    </el-aside>
    <el-container>
      <el-header height="72px">
        <AppHeader />
      </el-header>
      <el-main>
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import AppHeader from "./components/AppHeader.vue";
import AppSidebar from "./components/AppSidebar.vue";

export default {
  name: "LayoutIndex",
  components: {
    AppHeader,
    AppSidebar
  },
  watch: {
    $route: {
      immediate: true,
      handler(route) {
        const role = route.meta.role || "platform";
        this.$store.commit("platform/SET_ROLE", role);
      }
    }
  }
};
</script>
